export default String.raw`
@media screen and (max-width: 540px) {
    .reg-container__input-wrappers-personal-data > .form__input-wrapper:first-child {
        width: 48%;
    }
    
    .reg-container__input-wrappers-personal-data > .form__input-wrapper:last-child {
        width: 49%;
    }
    
    .reg-container__input-wrappers-home > .form__input-wrapper:first-child {
        width: 48%;
    }
    
    .reg-container__input-wrappers-home > .form__input-wrapper:last-child {
        width: 49%;
    }
  
    .reg-container__input-wrappers-city > .form__input-wrapper:first-child {
        width: 48%;
      }
    
      .reg-container__input-wrappers-city > .form__input-wrapper:last-child {
        width: 49%;
      }
  }
`